import React, { useContext } from 'react';
import { Routes, Route } from 'react-router-dom';
/* Dependencias */
import slugify from 'react-slugify';
/* Componentes */
import NoMatch from '../../no-match/NoMatch';
import Footer from '../../../components/layout/footer/Footer';
import Header from '../../../components/layout/header/Header';
import DynamicWordPressHeader from '../../../components/layout/header/DynamicWordPressHeader';
import MainSidebar from '../../../components/layout/sidebar/main-sidebar/MainSidebar';
import ReportsSidebar from '../../../components/layout/sidebar/reports-sidebar/ReportsSidebar';
import WordPressSidebar from '../../../components/layout/sidebar/wordpress-sidebar/WordPressSidebar';
import DynamicReportContentAutoSlug from '../../../components/reports/DynamicReportContentAutoSlug';
/* Reports Preview */
import EstudioConectividad2022Preview from '../report-preview/EstudioConectividad2022Preview';
import DNSOverTLSPreview from '../report-preview/DNSOverTLSPreview';
import OptimizacionIBgpPreview from '../report-preview/OptimizacionIBgpPreview';
import InterconexionBgpEnLaRegion from '../report-preview/InterconexionBgpEnLaRegionPreview';
import SecondBGPLac from '../report-preview/SecondBgpLacPreview';
import DNSAnycast from '../report-preview/DNSAnycastPreview';
import ConectividadRegional from '../report-preview/ConectividadRegionalPreview';
import RuteoLAC from '../report-preview/RuteoLACPreview';
import RootServer from '../report-preview/RootServerPreview';
import ResumenMejoresPracticasIXPPreview from '../report-preview/ResumenMejoresPracticasIXPPreview';
import IncidentesEnrutamiento2024 from '../report-preview/IncidentesEnrutamiento2024';
/* Reports */
import Conectividad2022 from '../reports/analisis-caminos-del-trafico/Conectividad2022';
import MejoresPracticasParaIXP from '../reports/mejores-practicas-ixp/MejoresPracticasParaIXP';
import ConectividadEnLac from '../reports/ContectividadEnLac/ConectividadEnLac';
import DNSOverTLS from '../reports/DNSOverTLS/DNSOverTLS';
import InterconexionBgp from '../reports/InterconexionBgp/InterconexionBgp';
import InterconexionBgpLocal from '../reports/InterconexionBgpLocal/InterconexionBgpLocal';
import OptimizacionRedesBgp from '../reports/OptimizacionRedesBgp/OptimizacionRedesBgp';
import UsoRootServerLAC from '../reports/UsoRootServerLAC/UsoRootServerLAC';
/* Hooks */
import UseLang from '../../../hooks/UseLang';
import useSmoothScroll from '../../../hooks/useSmoothScroll';
/* Context */
import { MenuContext, MobileContext } from '../../../context/DataContext';
/* Data */
import { reportData } from '../../../data/report-data/report-data/reportData';
import GenericWordPressReport from '../reports/evolucion-global-y-regional-de-la-adopcion-de-rpki/GenericWordPressReport';
import EvolucionGlobalRPKIPreview from '../report-preview/EvolucionGlobalRPKIPreview';
import AnalisisCaminosCadaPaisPrevew from '../report-preview/AnalisisCaminosCadaPaisPrevew';
import AnalisisDeFuncionamientoDelTrustAnchorTaDeRpkiV1Preview from '../report-preview/AnalisisDeFuncionamientoDelTrustAnchorTaDeRpkiV1Preview';
 
// Objeto que mapea los componentes con sus identificadores
const reportComponents = {
    incidentesEnrutamiento2024 : IncidentesEnrutamiento2024,
    conectividadEnLac: Conectividad2022,
    conectividad2020: ConectividadEnLac,
    mejoresPracticasIxp: MejoresPracticasParaIXP,
    dnsOverTls: DNSOverTLS,
    optimizacionRedesBgp: OptimizacionRedesBgp,
    interconexionBgp: InterconexionBgp,
    interconexionBgpLocal: InterconexionBgpLocal,
    rootServerLocal: UsoRootServerLAC,
    tiempoNubeAnycastLactldLac: DNSAnycast,
    seguridadRuteoLac: RuteoLAC, 
    evolucionGlobalRPKI:  GenericWordPressReport,
    rfc8950: GenericWordPressReport,
    analisisCaminosPaisLac: GenericWordPressReport,
    analisisDeFuncionamientoDelTrustAnchorTaDeRpkiV1: GenericWordPressReport, 
    // Agregar más reportes aquí
};

function HomeInterconnection({ lang, routes, myRoutes }) {
    const { isMobile } = useContext(MobileContext)
    const { isIndice, openIndice } = useContext(MenuContext)
    
    // Hook para manejar scroll suave con anclas
    useSmoothScroll();
    
    // Función para detectar si un componente es de WordPress
    const isWordPressComponent = (reportId) => {
        // Lista de componentes que usan WordPress
        const wordpressComponents = [
            'evolucionGlobalRPKI', 
            'rfc8950', 
            'analisisCaminosPaisLac', 
            'analisisDeFuncionamientoDelTrustAnchorTaDeRpkiV1'
        ];
        return wordpressComponents.includes(reportId);
    };
    
    // Función para obtener el slug de WordPress basado en el reportId
    const getWordPressSlug = (reportId) => {
        const slugMap = {
            
            'analisisCaminosPaisLac' : 'analisis-de-caminos-desde-cada-pais-hacia-el-resto-de-la-region',
            'evolucionGlobalRPKI': 'evolucion-global-y-regional-de-la-adopcion-de-rpki',
            'rfc8950' : 'implementacion-del-rfc8950-para-la-transicion-a-ipv6-only-soporte-de-ipv4aas-en-redes-mikrotik',
            'analisisDeFuncionamientoDelTrustAnchorTaDeRpkiV1' : 'analisis-de-funcionamiento-del-trust-anchor-ta-de-rpki'
        };
        return slugMap[reportId];
    };
    
    
    // Mantener compatibilidad con sistema actual - las rutas se generan desde reportData

    // Generar rutas dinámicamente desde reportData
    const generateRoutes = () => {
        return Object.entries(reportData).map(([reportId, reportContent]) => {
            const Component = reportComponents[reportId];
            if (!Component) return null;

            const isWordPress = isWordPressComponent(reportId);
            const wpSlug = isWordPress ? getWordPressSlug(reportId) : null;
            
            // Para componentes de WordPress, usar el slug de WordPress directamente
            // Para componentes normales, generar slug desde el título
            const sluggedPath = isWordPress ? wpSlug : slugify(reportContent[lang]?.title || reportContent.es.title);


            return (
                <Route
                    key={reportId}
                    path={sluggedPath}
                    element={<>
                        <Header
                            url_es={`/es/${myRoutes?.es?.interconexion}/${slugify(reportContent?.es?.title)}`}
                            url_en={`/en/${myRoutes?.en?.interconexion}/${slugify(reportContent?.en?.title)}`}
                            url_pt={`/pt/${myRoutes?.pt?.interconexion}/${slugify(reportContent?.pt?.title)}`}
                        />
                        <div className="report_work_table">
                            <div className="report_main_wrapper">
                                <div>
                                    {/* Sidebar lateral */}
                                    {((!isMobile) || (isMobile && isIndice)) && (
                                        <aside className={`lateral_menu_wrapper ${isMobile ? 'mobile_lateral_menu' : ''}`}>
                                            {isWordPress ? (
                                                <WordPressSidebar
                                                    slug={wpSlug}
                                                />
                                            ) : reportContent?.es?.items ? (
                                                <ReportsSidebar
                                                    menu_lateral={`${slugify(reportContent?.es?.title)}`}
                                                    category={'interconexion'}
                                                    routes={routes}
                                                    lang={lang}
                                                />
                                            ) : (
                                                <MainSidebar
                                                    category='interconexion'
                                                    lang={lang}
                                                    routes={routes}
                                                />
                                            )}
                                        </aside>
                                    )}
                                    
                                           {/* Contenido principal */}
                                           <main className="report_content_wrapper">
                                               <section>
                                                   {isWordPress ? (
                                                       <Component
                                                           displayMode="full"
                                                           lang={lang}
                                                           reportId={reportId}
                                                       />
                                                   ) : (
                                                       <Component
                                                           displayMode="full"
                                                           lang={lang}
                                                       />
                                                   )}
                                               </section>
                                           </main>
                                </div>
                            </div>
                        </div>
                        {isMobile &&
                            <div className="report_button_menu" onClick={openIndice}>
                                <div>
                                    {!isIndice && <i className="fas fa-list"></i>}
                                    {isIndice && <i className="fas fa-times"></i>}
                                </div>
                            </div>
                        }
                        <Footer {...footerProps} />
                    </>
                    }
                />
            );
        });
    };


    // Defino props con className para agregar al elemento Footer
    const footerProps = {
        className: `master_foot_reports ${!isMobile ? 'foot_report' : 'basic_foot'}`,
        ...((!isMobile) && { footer: 'reports' })
    };

    const createHome = () => {
        return (
            <Route
                index
                element={
                    <>
                        <Header
                            url_es={`/es/${myRoutes?.es?.interconexion}`}
                            url_en={`/en/${myRoutes?.en?.interconexion}`}
                            url_pt={`/pt/${myRoutes?.pt?.interconexion}`}
                        />
                        <div className="report_work_table">
                            <div className="report_main_wrapper">
                                <div>
                                    {!isMobile && (
                                        <aside className="lateral_menu_wrapper">
                                            <MainSidebar
                                                category='interconexion'
                                                lang={lang}
                                                routes={routes}
                                            />
                                        </aside>
                                    )}
                                    <main className="report_content_wrapper">
                                        <section>
                                            <div className="report_list">
                                                <UseLang es>Informes técnicos, Interconexión </UseLang>
                                                <UseLang en>Technical Reports, Interconnection</UseLang>
                                                <UseLang pt>Relatórios técnicos, Interconexão </UseLang> 
                                                <AnalisisDeFuncionamientoDelTrustAnchorTaDeRpkiV1Preview/>
                                                <AnalisisCaminosCadaPaisPrevew/>
                                                <EvolucionGlobalRPKIPreview/>
                                                <IncidentesEnrutamiento2024/>
                                                <ResumenMejoresPracticasIXPPreview />
                                                <EstudioConectividad2022Preview />
                                                <DNSOverTLSPreview />
                                                <OptimizacionIBgpPreview />
                                                <InterconexionBgpEnLaRegion />
                                                <SecondBGPLac />
                                                <DNSAnycast />
                                                <ConectividadRegional />
                                                <RuteoLAC />
                                                <RootServer />
                                                 
                                            </div>
                                        </section>
                                    </main>
                                </div>
                            </div>
                        </div>
                        <Footer
                            footer='reports'
                            className="master_foot_reports foot_report"
                        />
                    </>
                }
            />
        )
    }


    return (
        <Routes>
            {/* Ruta absoluta en "/es/interconexion" */}
            {createHome()}
            {/* Rutas para reportes de interconexion "/es/interconexion/reportContent?.es?.title"  */}
            {generateRoutes()}
            {/* Ruta catch-all para WordPress que acepte cualquier slug */}
            <Route
                path=":anySlug"
                element={<>
                    <DynamicWordPressHeader 
                        myRoutes={myRoutes}
                        category="interconexion"
                    />
                    <div className="report_work_table">
                        <div className="report_main_wrapper">
                            <div>
                                {/* Sidebar lateral */}
                                {((!isMobile) || (isMobile && isIndice)) && (
                                    <aside className={`lateral_menu_wrapper ${isMobile ? 'mobile_lateral_menu' : ''}`}>
                                        <WordPressSidebar
                                            slug={null} // Se detectará automáticamente
                                        />
                                    </aside>
                                )}
                                
                                {/* Contenido principal - usa DynamicReportContentAutoSlug para detectar el slug automáticamente */}
                                <main className="report_content_wrapper">
                                    <section>
                                        <DynamicReportContentAutoSlug />
                                    </section>
                                </main>
                            </div>
                        </div>
                    </div>
                    {isMobile &&
                        <div className="report_button_menu" onClick={openIndice}>
                            <div>
                                {!isIndice && <i className="fas fa-list"></i>}
                                {isIndice && <i className="fas fa-times"></i>}
                            </div>
                        </div>
                    }
                    <Footer {...footerProps} />
                </>
                }
            />
            {/* Rutas que no coinciden Ejemplo: "/es/interconexion/example" */}
            <Route path="*" element={<NoMatch />} />
        </Routes>
    );
}

export default HomeInterconnection;